<template>
	<article ref="scrollBox" class="bus_list_wrap home CompareFlightIndex">
		<Spin class="Loading" v-if="Loading">
			<Icon type="ios-loading" size="30" style="color:white" class="colorprimary demo-spin-icon-load"></Icon>
			<div style="color:white">支付中</div>
		</Spin>
		<header class="pages_title">
			<div class="myHeader flexContainer">
				<div class="myHeaderL" @click="clearLast()"><i class="iconfont_new icon-Left"></i></div>
				<div class="myHeader textalignM">
					<span>{{ isDep ? depCity : arrCity }}→{{ isDep ? arrCity : depCity }}</span>
				</div>
				<div class="myHeaderR textalignR"></div>
			</div>
		</header>

		<section class="pages_content">
			<div class="comfirm">
				<!-- <template > -->
				<div class="hangbanBox" :key="index" v-for="(item, index) in selectedFlightList">
					<!-- <div class="hangbanItem" @click="goDetail(dataList.id)"> -->
					<div class="hangbanItem">
						<div class="flexContainer">
							<div class="flexItem1 flight-plane">
								<img :src="item.airCompanyLogoImg" style="height: 0.5rem;margin-top: -0.2rem;" />
								{{ item.airCompanyName }} {{ item.flightNo }}
							</div>
							<div class="flightType" v-if="flightType == 1">单程</div>
							<div class="flightType" v-if="flightType == 2 && selectedFlightList.length == 2 && index == 0">去程</div>
							<div class="flightType" v-if="flightType == 2 && selectedFlightList.length == 2 && index == 1">返程</div>
						</div>
						<div class="flexContainer">
							<div class="flexItem3">
								<div class="flexContainer flight-info-wrap">
									<div class="flexItem1 textalignR">
										<div class="flight-timeSmall">{{ item.depTime }}</div>
										<div class="flight-deparrDate">{{ item.depDate }}</div>
										<div class="flight-airport">{{ item.depCityName + item.depAirportName + item.depTerminal }}</div>
									</div>
									<div class="icon-arrow"></div>
									<div class="flexItem1">
										<div class="flight-timeSmall">{{ item.arrTime }}</div>
										<div class="flight-deparrDate">{{ item.arrDate }}</div>
										<div class="flight-airport">{{ item.arrCityName + item.arrAirportName + item.arrTerminal }}</div>
									</div>
								</div>
							</div>
						</div>

						<div class="flexContainer">
							<div class="flexItem1 textalignR">
								<div class="flight-plane tag-advantage">
									<span v-if="item.isHasMeal == 1" style="margin-right:5px;">
										<i class="iconfont_new icon-canyin flight-planeIcon"></i>
										&nbsp;有餐食
									</span>
									<span v-if="item.stopNum == 0">
										<i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
										&nbsp;直飞
									</span>
									<span v-else>
										<i class="iconfont_new icon-feiji800 flight-planeIcon"></i>
										&nbsp;经停{{ item.stopNum }}次
									</span>
								</div>
							</div>
						</div>

						<div class="flexContainer" style="border-top:1px dashed #eaeaea;margin-top: 0.2rem;">
							<div class="flexItem3 flight-info-wrap marginT0">
								<i class="iconfont_new icon-zuowei1"></i>
								{{ selectedPolicyList[index].cabin[0].cabinCode }}舱&nbsp;&nbsp;
								<span class="freeTicket" v-if="selectedPolicyList[index].isFreeBusTicket && (businessInfo.ShortName == 'zsairport')">该航班舱位可获赠免费车票</span>
							</div>
							<div class="flexItem1 textalignR">
								<div class="flight-number marginT0">
									<dfn>¥</dfn>
									<strong>{{ selectedPolicyList[index].priceDatas[0].price }}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </template> -->

				<div class="hangbanBox" style="margin-top:0.25rem;" v-if="isAbleToBuyBusTicket && (businessInfo.ShortName == 'zsairport')">
					<div class="hangbanItem">
						<div class="flexContainer" @click="showBusQuestion" :disabled="!hasSubmitOrder">
							<div style="margin-right:10px;">
								<i class="iconfont_new icon-duihao radioDiv" v-bind:class="{ radioDivCheck: isNeedBusTicket }" style="margin-top:0;"></i>
							</div>
							<div class="flexItem1 textalignR">
								<div class="color1 fontSize35 fontWeightChang">
									<span class="miaoshaText">免站场服务费</span>
									是否需要机场大巴
									<!-- <i class="iconfont_new icon-toubaoxuzhi" style="color:red;font-size:0.4rem!important;" @click.stop="showQuestion"></i> -->
								</div>
							</div>
						</div>

						<div v-if="isNeedBusTicket && SelectedFrequency != null" style="border-top: 1px solid #eaeaea;padding-top: 10px;margin-top:5px;">
							<div class="flexContainer">
								<div class="flexItem3">
									<div class="flexContainer flight-info-wrap">
										<div class="flexItem1 textalignR">
											<div class="flight-timeSmall">{{ getOn }}</div>
											<div class="flight-airport">{{ SelectedFrequency.SetTime.replace('T', ' ') }}</div>
										</div>
										<div class="icon-arrow" style="margin-top:0.4rem;"></div>
										<div class="flexItem1">
											<div class="flight-timeSmall">{{ getOff }}</div>
											<div class="flight-number" style="text-align: right;margin-top:0;">
												<dfn>¥</dfn>
												<strong>{{ totalTicketPrice }}</strong>
											</div>
										</div>
									</div>
								</div>
							</div>
							<p style="line-height: 0.6rem;color:#ed4014;margin-top: 0.5rem;font-weight: 400;">
								<i class="iconfont_new icon-xuzhixiao" style="margin-right:5px;color:#006535;"></i>
								{{ getOn }}-{{ getOff }}车程约为{{ SelectedFrequency.TotalMinute }}分钟，国内航班起飞前45分钟停办登机手续，请预留充足的候机时间。
							</p>
						</div>
					</div>
				</div>

				<div class="hangbanBox" style="margin-top:0.25rem;" v-if="(businessInfo.ShortName == 'zsairport')">
					<div class="hangbanItem">
						<div class="flexContainer" @click="showPickupQuestion" :disabled="!hasSubmitOrder">
							<div style="margin-right:10px;">
								<i class="iconfont_new icon-duihao radioDiv" v-bind:class="{ radioDivCheck: isNeedPickup }" style="margin-top:0;"></i>
							</div>
							<div class="flexItem1 textalignR">
								<div class="color1 fontSize35 fontWeightChang">
									<span class="miaoshaText">一口价</span>
									是否需要接送
									<i
										class="iconfont_new icon-toubaoxuzhi"
										style="color:#ed4014;font-size:0.4rem!important;"
										@click.stop="showPickupQuestion"
										:disabled="!hasSubmitOrder"
									></i>
								</div>
							</div>
						</div>

						<div v-if="isNeedPickup" style="border-top: 1px solid #eaeaea;padding-top: 10px;margin-top:5px;">
							<div class="flexContainer difangInput" @click="choosePickupAddress" :disabled="!hasSubmitOrder">
								<div class="color1 fontSize35">
									<i class="iconfont_new icon-dingwei2" style="font-size:0.5rem;"></i>
									出发地：
								</div>
								<div class="flexItem1 textalignR color1 fontSize35">
									<input
										type="text"
										class="noBorderInput fontWeightChang"
										style="text-align: right;"
										:value="DefaultAddress.District + '-' + DefaultAddress.Address"
									/>
								</div>
							</div>
							<div class="flexContainer difangInput">
								<div class="color1 fontSize35">
									<i class="iconfont_new icon-dingwei2" style="font-size:0.5rem;"></i>
									目的地：
								</div>
								<div class="flexItem1 textalignR color1 fontSize35">
									<input type="text" class="noBorderInput fontWeightChang" style="text-align: right;" :value="bookingEndAddr" disabled="true" />
								</div>
							</div>
						</div>

						<div v-if="isNeedPickup" class="flexContainer" style="border-top:1px dashed #eaeaea;margin-top: 0.2rem;">
							<div class="flexItem3 flight-info-wrap marginT0"></div>
							<div class="flexItem1 textalignR">
								<div class="flight-number marginT0">
									<dfn>¥</dfn>
									<strong>{{ totalPickupPrice }}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="personBox">
					<div class="flexContainer" style="padding:0 0 0.25rem 0;border-bottom:1px solid #eaeaea;">
						<div class="flexItem1 color1 fontSize35">
							<i class="iconfont_new icon-adduser personTelIcon"></i>
							乘机人
						</div>
					</div>

					<div class="personBoxItem color1 fontSize35" v-for="(passenger, index) in passengerList" :key="passenger.RealName">
						<div class="flexContainer">
							<div class="flexItem1">
								<i class="iconfont_new icon-shenfen4 personIcon"></i>
								{{ passenger.RealName }} {{ passenger.CardNO }}
							</div>
							<div class="textalignR">
								<i
									class="iconfont_new icon-close personCloseIcon"
									style="font-size:0.5rem!important;margin-right: 0.5rem;"
									@click="deletePassenger(passenger, index)"
									:disabled="!hasSubmitOrder"
								></i>
							</div>
						</div>
						<div class="priceDetailInfo color3">
							<div class="flexContainer">
								<div class="priceDetailInfo_t" style="width: 200px;">票价</div>
								<div class="flexItem1"><div class="itemBorder"></div></div>
								<div class="priceDetailInfo_p colorprimary">¥{{ passenger.ticketPrice }}</div>
							</div>
							<div class="flexContainer">
								<div class="priceDetailInfo_t" style="width: 200px;">机场建设税</div>
								<div class="flexItem1"><div class="itemBorder"></div></div>
								<div class="priceDetailInfo_p colorprimary">¥{{ passenger.airportTax }}</div>
							</div>
							<div class="flexContainer">
								<div class="priceDetailInfo_t" style="width: 200px;">开票费</div>
								<div class="flexItem1"><div class="itemBorder"></div></div>
								<div class="priceDetailInfo_p colorprimary">¥{{ passenger.billingFee }}</div>
							</div>
							<div class="flexContainer">
								<div class="priceDetailInfo_t" style="width: 200px;">手续费</div>
								<div class="flexItem1"><div class="itemBorder"></div></div>
								<div class="priceDetailInfo_p colorprimary">¥{{ passenger.charge }}</div>
							</div>
						</div>
					</div>

					<div class="personButton" @click="addPassenger" :disabled="!hasSubmitOrder">
						<i class="iconfont_new icon-add1"></i>
						&nbsp;&nbsp;点击添加乘客
					</div>
				</div>

				<div class="rule">
					订单包含机票、附加选购产品、机场建设费、燃油费、税费。
					<br />
					点击“去支付”表示已经阅读并同意"航意航延组合险保险条款","锂电池及危险品须知","机票预订须知","活动价格说明","机票增值服务供应商资质"
				</div>

				<TicketTipsModel :show="ifshowFlightTicketTips" @close="closeTicketTips"></TicketTipsModel>
			</div>
		</section>

		<footer class="myFooter">
			<div class="footerRule">
				<Checkbox v-model="isAgree">我已阅读并同意</Checkbox>
				<span @click="ifshowFlightTicketTips = true">《中山候机楼机票预定须知》</span>
			</div>
			<div class="flexContainer">
				<div class="flexItem1">
					<div class="myFooterPrice">
						<span class="myFooterPriceIcon">¥</span>
						{{ totalPrice }}
					</div>
				</div>
				<div class="myFooterBtnDiv"><div class="myFooterBtn" @click="goNextPage()">去支付</div></div>
			</div>
		</footer>
	</article>
</template>

<script>
import { mapState } from 'vuex';
import appointApi from '../request/appointApi';
import baseTool from '../utils/baseFunction';
import flightApi from '../request/flightApi';
import orderApi from '../request/orderApi';
import businessApi from '../request/businessApi';
import paymentApi from '../request/paymentApi';
import TicketTipsModel from '@/components/child-components/TicketTipsModel';
export default {
	name: 'FlightOrderConfirm',
	data() {
		return {
			paramsName: '', // 商户参数
			businessInfo: null, // 商户信息
			businessAddressList: [], // 商户地址

			bookingEndAddr: '',

			getOn: '',
			getOff: '',

			from: '北京',
			to: '南京',

			isNeedBusTicket: false,
			isNeedPickup: false,

			isFreeBusTicket: false,

			chufadi: '西区',
			mudidi: '广州南站',

			passengerList: [], // 旅客列表
			isAbleToOrder: false, // 是否可下单
			contactName: '', // 订单联系人
			contactMobile: '', // 订单联系人电话
			totalFlightPrice: 0, // 订单总价
			totalTicketPrice: 0, // 车票总价
			totalPickupPrice: 0, // 接送价
			flightOrderData: null,
			ticketOrderData: null,
			appointOrderData: null,
			hasSubmitOrder: false, // 是否已提交订单，则界面不能变动。

			isAgree: false, //是否勾选同意
			ifshowFlightTicketTips: false, //是否显示《中山候机楼机票预定须知》

			Loading: false
		};
	},
	activated() {
		let that = this;
		this.Loading = false;
		this.flightOrderData = null;
		this.ticketOrderData = null;
		this.appointOrderData = null;
		this.hasSubmitOrder = false;

		if (this.$route.params.name && this.$route.params.name.length > 0) {
			this.paramsName = this.$route.params.name;
			//根据标识获取商户信息
			this.getBusinessInfo();
			//获取商户列表
			this.getBusinessAddressList();
		}

		this.passengerList = this.$store.state.ticket.ContactList;

		if (this.selectedFlightList.length == 0 || this.selectedPolicyList.length == 0) {
			alert('请先选择航班与舱位！');
			if (this.paramsName != '') {
				that.$router.replace({
					name: 'FlightIndexPage',
					params: {
						page: 'scopeindex',
						PlaceName: that.paramsName
					}
				});
			} else {
				that.$router.replace({
					name: 'FlightIndexPage',
					params: {
						page: 'scopeindex',
						PlaceName: that.paramsName
					}
				});
			}
			// } else {
			// 	this.$router.replace({
			// 		name: 'CompareFlightIndex'
			// 	});
			// }
		}
		console.log('confirm-selectedPolicyList->', this.selectedPolicyList);

		this.checkFlightEvent();

		if (this.paramsName == 'zsairport') {
			this.computedBusTicketPrice();
			this.computedFlightPrice();
			this.computedPickupPrice();
		} else {
			this.computedBusTicketPrice();
			this.computedFlightPrice();
		}
	},
	components: {
		TicketTipsModel: TicketTipsModel
	},
	mounted() {},
	methods: {
		checkFlightEvent() {
			let that = this;
			let tmpFlight = this.selectedFlightList[0];
			let tmpPolicy = this.selectedPolicyList[0];
			if (tmpFlight.depCityName == '广州') {
				if (tmpFlight.airCompanyName == '中国国航') {
					this.isFreeBusTicket = true;
				}
			} else if (tmpFlight.depCityName == '珠海' && tmpFlight.airCompanyName == '南方航空' && tmpFlight.arrAirportName == '大兴机场') {
				let freeCabinList = 'KUALQEVZTNR';
				let cabinCode = tmpPolicy.cabin[0].cabinCode;
				if (freeCabinList.indexOf(cabinCode) != -1) {
					this.isFreeBusTicket = true;
				}
			}
		},
		computedFlightPrice() {
			let basePrice = 0;
			this.isAbleToOrder = false;
			if (!this.passengerList || this.passengerList.length == 0) this.totalFlightPrice = basePrice;
			this.passengerList.forEach(psg => {
				psg['airportTax'] = 0;
				psg['ticketPrice'] = 0;
				psg['fuelTax'] = 0;
				psg['billingFee'] = 0;

				if (this.depCity == '珠海') psg['charge'] = 30;
				else psg['charge'] = 50;

				if (psg.PapersType == '身份证') {
					if (psg.CardNO.length != 15 && psg.CardNO.length != 18) this.data.isPriceSuccess = false;
					if (psg.Birthday == null || psg.Birthday == '') this.data.isPriceSuccess = false;
				}
				let isAdult = psg.AgeType == 1 ? true : false;
				if (isAdult && this.contactName == '' && this.contactMobile == '') {
					this.contactName = psg.RealName;
					this.contactMobile = psg.Mobile;
				}

				this.selectedPolicyList.forEach(policy => {
					let adultPrice, childPrice;
					policy.priceDatas.forEach(price => {
						if (price.crewType == '1') {
							adultPrice = price;
						} else if (price.crewType == '2') {
							childPrice = price;
						}
					});

					if (isAdult) {
						psg['airportTax'] += adultPrice.airportTax;
						psg['ticketPrice'] += adultPrice.price;
						psg['fuelTax'] += adultPrice.fuelTax;
						psg['billingFee'] += adultPrice.billingFee;
					} else {
						psg['ticketPrice'] += adultPrice.price;
						this.isAbleToOrder = false;
					}
				});
				basePrice += psg['ticketPrice'];
				basePrice += psg['airportTax'];
				basePrice += psg['fuelTax'];
				basePrice += psg['charge'];
				basePrice += psg['billingFee'];
			});
			this.totalFlightPrice = basePrice;
			// if (!this.isAbleToOrder) {
			// 	this.$Modal.warning({
			// 		title: '提示',
			// 		content: `资料校验失败，可能存在以下问题：（1）身份证校验失败或出生年月未填写，请编辑完善乘客资料信息。（2）目前尚不支持出儿童票，请选择成人旅客，敬请谅解。`
			// 	});
			// } else {
			// 	this.totalFlightPrice = basePrice;
			// 	this.computedTicketPrice();
			// }
		},
		computedPickupPrice() {
			let that = this;
			let basePrice = 0;
			if (!this.isNeedPickup) this.totalPickupPrice = basePrice;
			if (this.passengerList && this.passengerList.length > 4) {
				this.isNeedPickup = false;
				this.totalPickupPrice = basePrice;
			}

			let startAddr = this.DefaultAddress.Address;
			let startCity = this.DefaultAddress.City;
			let endAddr = this.bookingEndAddr;
			let endCity = this.$store.state.appoint.CityName;
			if (startAddr == '' || startCity == '' || endAddr == '' || endCity == '') {
				// alert('地址不全，无法计算接送费用。');
				this.totalPickupPrice = basePrice;
			}
			let startLocation, endLocation;
			appointApi.convertAddressToLocation(startCity, startAddr).then(startRes => {
				if (startRes.status == '1' && startRes.info == 'OK' && startRes.pois && startRes.pois.length > 0) {
					startLocation = startRes.pois[0].location;
					appointApi.convertAddressToLocation(endCity, endAddr).then(endRes => {
						if (endRes.status == '1' && endRes.info == 'OK' && endRes.pois && endRes.pois.length > 0) {
							endLocation = endRes.pois[0].location;
							// 直线距离(米)
							let StraighDistance = baseTool.getDistance(
								Math.abs(startLocation.split(',')[0]),
								Math.abs(startLocation.split(',')[1]),
								Math.abs(endLocation.split(',')[0]),
								Math.abs(endLocation.split(',')[1])
							);
							that.setAppointStore({
								bookingStartPointLa: startLocation.split(',')[0],
								bookingStartPointLo: startLocation.split(',')[1],
								bookingEndPointLa: endLocation.split(',')[0],
								bookingEndPointLo: endLocation.split(',')[1]
							});
							// 直线距离（公里）
							let longDistance = Math.ceil(StraighDistance / 1000);
							basePrice += 15;
							if (longDistance > 2) basePrice += (longDistance - 2) * 3;

							if (longDistance < 10) {
								if (basePrice > 15) {
									basePrice = Math.ceil(basePrice * 0.9);
								}
							} else if (longDistance >= 10 && longDistance < 15) {
							} else if (longDistance >= 15 && longDistance < 20) {
								basePrice = basePrice + Math.ceil(basePrice * 0.05);
							} else if (longDistance >= 20 && longDistance < 25) {
								basePrice = basePrice + Math.ceil(basePrice * 0.1);
							} else if (longDistance >= 25 && longDistance < 30) {
								basePrice = basePrice + Math.ceil(basePrice * 0.15);
							} else if (longDistance >= 30) {
								basePrice = basePrice + Math.ceil(basePrice * 0.15);
							}

							let flightHour = that.selectedFlightList[0].depTime.split(':')[0];
							if (flightHour <= 10) basePrice += 10; // 10点前航班，都要提早。
							// 超行李费用
							if (that.LuggageCount > 0 && that.LuggageCount > that.passengerList.length) {
								basePrice += (that.LuggageCount - that.passengerList.length) * 10;
							}
							that.totalPickupPrice = basePrice;
						} else {
							alert('无法解析终点坐标！');
							that.totalPickupPrice = basePrice;
						}
					});
				} else {
					alert('无法解析起点坐标！');
					that.totalPickupPrice = basePrice;
				}
			});
		},
		computedBusTicketPrice() {
			let that = this;
			this.totalTicketPrice = 0;
			if (!this.isNeedBusTicket) {
				this.totalTicketPrice = 0;
				return;
			}
			for (let i = 0; i < this.passengerList.length; i++) {
				this.passengerList[i]['TicketType'] = '成人';
				this.passengerList[i]['ExtraService'] = [];
				let contact = this.passengerList[i];
				let isVip = contact.IsVip;
				let totalPrice = 0,
					ticketPrice = 0,
					stationServicePrice = 5,
					overTimePrice = 0,
					pickupPrice = 0;

				var set = '';

				switch (contact.TicketType) {
					case '成人':
						if (isVip) totalPrice += this.SelectedFrequency.VipPrice;
						else totalPrice += this.SelectedFrequency.Price;

						// 已购机票
						if (this.isFreeBusTicket) {
							// 先判断是否免费车票
							ticketPrice = 0;
							totalPrice = 0;
							stationServicePrice = 0;
						} else {
							// 非免费车票，减免站场服务费
							ticketPrice = totalPrice - 5;
							totalPrice -= 5;
							stationServicePrice = this.SelectedFrequency.GetOff == '珠海机场' ? 0 : 5;
						}
						break;
					case '小童':
						totalPrice += this.SelectedFrequency.HalfTicketPrice;

						if (this.data.isFreeTicket) {
							// 先判断是否免费车票
							ticketPrice = 0;
							totalPrice = 0;
							stationServicePrice = 0;
						} else {
							// 非免费车票，减免站场服务费
							ticketPrice = totalPrice;
							stationServicePrice = 0;
						}
						break;
					case '婴儿':
						totalPrice += 0;
						break;
					case '军人残疾':
						totalPrice += this.SelectedFrequency.DisabledArmymanTicketPrice;

						// 已购车票
						if (this.data.isFreeTicket) {
							// 先判断是否免费车票
							ticketPrice = 0;
							totalPrice = 0;
							stationServicePrice = 0;
						} else {
							// 非免费车票，减免站场服务费
							ticketPrice = totalPrice - 5;
							totalPrice -= 5;
							stationServicePrice = 0;
						}
						break;
				}
				this.passengerList[i].StationServicePrice = stationServicePrice;
				this.passengerList[i].TicketPrice = ticketPrice;
				this.passengerList[i].PickupPrice = pickupPrice;
				this.passengerList[i].OverTimePrice = overTimePrice;
				this.passengerList[i].computedPrice = totalPrice;

				this.totalTicketPrice += totalPrice;
			}
			// this.getTotalPrice();
		},
		getTotalPrice() {
			let that = this;
			orderApi.getTicketTotalPrice(1, this.SelectedFrequency.ID, '', this.LuggageCount, '', false, this.passengerList, this.isFreeBusTicket).then(sucRes => {
				if (sucRes.success) {
					this.totalTicketPrice = sucRes.data.TotalPrice;
				}
			});
		},
		//关闭弹窗：《中山候机楼机票预定须知》
		closeTicketTips(value) {
			this.ifshowFlightTicketTips = value;
		},
		getBusinessInfo() {
			var that = this;
			//获取商户信息
			businessApi.getBusinessInfo(this.paramsName).then(res => {
				if (res.success) {
					this.businessInfo = res.data;
					this.setAppointStore({
						businessSign: this.paramsName
					}); // new
					console.log(this.businessInfo);
				} else {
					alert(res.message);
					that.$router.replace({
						name: 'FlightIndexPage',
						params: {
							page: 'scopeindex',
							PlaceName: 'zsairport'
						}
					});
				}
			});
		},
		getBusinessAddressList() {
			//获取商户地址列表
			businessApi.getBusinessAddressList(this.paramsName).then(res => {
				if (res.success) {
					this.businessAddressList = res.data;
					this.businessAddressList.forEach(item => {
						if (item.IsDefault) {
							this.bookingEndAddr = item.MarkName;
							this.setAppointStore({
								MarkName: item.MarkName, // new
								bookingEndAddr: item.Address,
								bookingEndPointLo: item.Longitude,
								bookingEndPointLa: item.Latitude
							});
						}
					});
				}
			});
		},
		choosePickupAddress() {
			this.$router.push({
				name: 'ChoosePickupService'
			});
		},
		// 更新约车store
		setAppointStore(updateObj) {
			this.$store.commit('appoint/setData', updateObj);
		},
		// 更新机票store
		setFlightStore(updateObj) {
			this.$store.commit('flight/setFlightQueryCondition', updateObj);
		},
		// 更新车票store
		setTicketStore(updateObj) {
			this.$store.commit('ticket/setBaseTicketCondition', updateObj);
		},
		// 选择旅客
		addPassenger() {
			this.setTicketStore({
				ContactList: []
			});
			this.passengerList = [];
			this.$router.push({
				name: 'MyContactManager',
				params: {
					mode: 'choose'
				}
			});
		},
		//删除单个联系人
		deletePassenger(obj, index) {
			// let tmpPsgList = Object.create(this.passengerList.filter(item => item.ID != obj.ID));
			this.passengerList.splice(index, 1);

			this.computedFlightPrice();
			this.computedPickupPrice();
			this.computedBusTicketPrice();
			this.setTicketStore({
				ContactList: this.passengerList
			});
		},
		showBusQuestion() {
			let that = this;
			if (this.isAbleToBuyBusTicket) {
				this.$Modal.confirm({
					title: '服务提示',
					content:
						'是否需要购买' +
						this.bookingEndAddr +
						'到' +
						this.depCity +
						'机场大巴？<br/><br/>预定机场大巴车票：<br/>1.指定航线送相应机场大巴车票<br/>2.预售机场大巴车票，免收取战场维护费10元/人',
					onOk: () => {
						that.isNeedBusTicket = true;
						that.getOn = '懿峯亚朵酒店候机楼';
						that.getOff = that.selectedFlightList[0].depCityName + '机场';
						that.setTicketStore({
							SetDate: that.selectedFlightList[0].depDate,
							GetOn: '懿峯亚朵酒店候机楼',
							GetOff: that.selectedFlightList[0].depCityName + '机场',
							SelectedFrequency: []
						});
						this.$router.push({
							name: 'ChooseFrequencyList',
							params: {
								mode: 2
							}
						});
					},
					onCancel: () => {
						this.isNeedBusTicket = false;
					}
				});
			}
		},
		showPickupQuestion() {
			let that = this;
			this.$Modal.confirm({
				title: '服务提示',
				content: '请问是否需要中山候机楼家门口接送服务？<br/><br/>1.不受里程限制，不受堵车限制<br/>2.专人专车安全有保障<br/>3.家门口接送更贴心<br/>4.一口价一人成行',
				onOk: () => {
					that.isNeedPickup = true;
					that.choosePickupAddress();
				},
				onCancel: () => {
					that.isNeedPickup = false;
				}
			});
		},
		createOrder() {
			var that = this;
			that.Loading = true;
			that.hasSubmitOrder = true;
			flightApi
				.createFlightOrder(
					this.OpenId,
					this.contactName,
					this.contactMobile,
					'',
					'',
					'',
					this.flightType,
					this.cabinRank,
					this.psgType,
					this.passengerList,
					this.selectedFlightList,
					this.selectedPolicyList,
					this.paramsName
				)
				.then(sucRes => {
					that.Loading = false;
					if (sucRes.success) {
						that.flightOrderData = sucRes.data;
						if (that.isNeedBusTicket) {
							orderApi
								.createTicketOrder(
									that.OpenId,
									that.GetOn,
									that.GetOff,
									[that.SelectedFrequency],
									that.passengerList,
									'',
									'',
									that.flightOrderData.DepFlightNo,
									that.isFreeBusTicket,
									that.flightOrderData.OrderNum
								)
								.then(ticketSucRes => {
									if (ticketSucRes.success) {
										that.ticketOrderData = ticketSucRes.data;
									}
								});
						}
						if (that.isNeedPickup) {
							let tmpAppointDate = baseTool.addHour(that.flightOrderData.DepDate.replace('T', ' ').replace('-', '/'), -5);
							console.log(tmpAppointDate);
							orderApi
								.createBusinessAppointOrderNew(
									that.OpenId,
									that.contactName,
									that.businessName,
									that.MarkName,
									that.passengerList.length,
									that.LuggageCount,
									tmpAppointDate,
									that.serviceType,
									that.contactMobile,
									that.DefaultAddress.District,
									that.DefaultAddress.Address,
									that.bookingStartPointLa,
									that.bookingStartPointLo,
									that.DefaultAddress.City,
									that.totalPickupPrice,
									`机票接送，航班号：${that.flightOrderData.DepFlightNo},起飞时间：${that.flightOrderData.DepDate}`,
									1,
									'noLimit',
									false,
									that.Location,
									that.name
								)
								.then(appointSucRes => {
									if (appointSucRes.success) {
										that.appointOrderData = appointSucRes.data;
									}
								});
						}

						let tmpTimer = setInterval(() => {
							let ticketSuccess = false;
							let appointSuccess = false;
							if (that.isNeedBusTicket) {
								if (that.ticketOrderData && that.ticketOrderData.ID && that.ticketOrderData.ID > 0) {
									ticketSuccess = true;
								} else ticketSuccess = false;
							} else ticketSuccess = true;

							if (that.isNeedPickup) {
								if (that.appointOrderData && that.appointOrderData.ID && that.appointOrderData.ID > 0) {
									appointSuccess = true;
								} else appointSuccess = false;
							} else appointSuccess = true;
							if (ticketSuccess && appointSuccess) {
								clearInterval(tmpTimer);
								that.payRequests();
							}
						}, 1000);
					} else {
						that.$Modal.confirm({
							title: '服务提示',
							content: sucRes.message,
							onOk: () => {
								that.createOrder();
							},
							onCancel: () => {}
						});
					}
				});
		},
		//跳转到“去支付”
		goNextPage() {
			if (!this.isAgree) {
				this.$Modal.error({
					title: '提示',
					content: '请阅读并同意《中山候机楼机票预定须知》'
				});
				return;
			}
			// this.$router.push({
			// 	name: 'order-result'
			// });
			let that = this;
			if (!this.passengerList || this.passengerList.length == 0) {
				alert('请选择乘客。');
				this.addPassenger();
				return;
			}
			let confirmMsg = this.buildConfirmMsg();
			this.$Modal.confirm({
				title: '操作提示',
				content: confirmMsg,
				onOk: () => {
					that.createOrder();
				},
				onCancel: () => {}
			});
		},
		buildConfirmMsg() {
			let flightMsg = '';
			this.selectedFlightList.forEach(flight => {
				flightMsg += `${flight.depDate}${flight.depCityName}-${flight.arrCityName}${flight.flightNo},${flight.depTime}起飞${flight.arrTime}到达。<br/>`;
			});
			let psgMsg = '';
			this.passengerList.forEach(psg => {
				psgMsg += `${psg.RealName}${psg.CardNO},<br/>`;
			});
			let pickupMsg = '';
			let warningMsg = `是否确认预定<br/>${flightMsg}共${this.passengerList.length}人。<br/>${psgMsg}请仔细核对订票信息，一经付款出票，变更退票执行航空公司政策。`;
			return warningMsg;
		},
		payRequests() {
			let that = this;
			if (!this.flightOrderData || !this.flightOrderData.ID) return;
			paymentApi
				.getWeChatPaySetParams(
					this.OpenId,
					2,
					this.flightOrderData.OrderNum,
					this.isNeedBusTicket ? this.ticketOrderData.OrderNum : '',
					this.isNeedPickup ? this.appointOrderData.OrderNum : ''
				)
				.then(sucRes => {
					wx.chooseWXPay({
						timestamp: sucRes.data.timeStamp,
						nonceStr: sucRes.data.nonceStr,
						package: sucRes.data.package,
						signType: sucRes.data.signType,
						paySign: sucRes.data.paySign,
						// 支付成功回调函数
						success: res => {
							// alert('success->', JSON.stringify(res));
							if (res.errMsg === 'chooseWXPay:ok') {
								that.$Modal.success({
									title: '温馨提示',
									content: '支付成功，正在等待出票，请关注《中山市旅游集散中心》公众号以便接收出票通知。',
									onOk: () => {
										that.$router.replace({
											name: 'FlightIndexPage',
											params: {
												page: 'myorder',
												PlaceName: that.paramsName
											}
										});
									}
								});
							}
						},
						// 支付取消回调函数
						cancel: cancel => {
							// alert('cancel->', JSON.stringify(cancel));
							that.$Modal.error({
								title: '温馨提示',
								content: '取消支付',
								onOk: () => {
									that.$router.replace({
										name: 'FlightIndexPage',
										params: {
											page: 'myorder',
											PlaceName: that.paramsName
										}
									});
								}
							});
						},
						// 支付失败回调函数
						fail: fail => {
							// this.$Message.warning('支付失败！');
							// this.getOrderList();
							that.$Modal.error({
								title: '温馨提示',
								content: '支付失败',
								onOk: () => {
									that.$router.replace({
										name: 'FlightIndexPage',
										params: {
											page: 'myorder',
											PlaceName: that.paramsName
										}
									});
								}
							});
						}
					});
				});
		},

		//返回上一页，删除最后一个舱位记录：
		clearLast() {
			let selectedPolicyList = [...this.selectedPolicyList];
			selectedPolicyList.pop();

			this.$store.commit('flight/setFlightQueryCondition', {
				selectedPolicyList: selectedPolicyList,
				ifBackRefresh: false //后退不刷新
			});
			this.$router.go(-1);
		}
	},
	computed: mapState({
		MarkName: state => state.appoint.MarkName,
		businessName: state => state.appoint.businessSign,
		serviceType: state => state.appoint.serviceType,
		bookingStartPointLa: state => state.appoint.bookingStartPointLa,
		bookingStartPointLo: state => state.appoint.bookingStartPointLo,
		Location: state => state.user.Location,

		isDep: state => state.flight.isDep,
		depDate: state => state.flight.depDate,
		backDate: state => state.flight.backDate,
		depCity: state => state.flight.depCity,
		depCityPortCode: state => state.flight.depCityPortCode,
		arrCity: state => state.flight.arrCity,
		arrCityPortCode: state => state.flight.arrCityPortCode,
		airCompanyCode: state => state.flight.airCompanyCode,
		airCompanyName: state => state.flight.airCompanyName,
		flightType: state => state.flight.flightType,
		psgType: state => state.flight.psgType,
		cabinRank: state => state.flight.cabinRank,
		directFlight: state => state.flight.directFlight,
		selectedFlightList: state => state.flight.selectedFlightList,
		selectedPolicyList: state => state.flight.selectedPolicyList,
		OpenId: state => state.user.OpenId,
		contactList: state => state.ticket.ContactList,
		DefaultAddress: state => state.ticket.DefaultAddress,
		LuggageCount: state => state.ticket.LuggageCount,
		SelectedFrequency: state => state.ticket.SelectedFrequency[0],
		GetOn: state => state.ticket.GetOn,
		GetOff: state => state.ticket.GetOff,
		SetDate: state => state.ticket.SetDate,
		// endAddress: state => state.appoint.endAddress,
		totalPrice() {
			return this.totalFlightPrice + (this.isNeedBusTicket ? this.totalTicketPrice : 0) + (this.isNeedPickup ? this.totalPickupPrice : 0);
		},
		// 判断是否有适合的大巴车票可选购
		isAbleToBuyBusTicket() {
			let isAble = false;
			let tmpFlightModel = this.selectedFlightList[0];
			let depCityName = tmpFlightModel.depCityName;
			if (depCityName.indexOf('广州') != -1 || depCityName.indexOf('珠海') != -1 || depCityName.indexOf('深圳') != -1) {
				isAble = true;
				// this.bookingEndAddr = '中山城市候机楼';
			}
			if (!isAble) {
				this.isNeedBusTicket = false;
			}
			return isAble;
		}
	})
};
</script>

<style scoped lang="less">
@import '../style/home.less';

.pages_title {
	background-color: transparent;
	padding: 0;
	color: #fff;
	border-bottom: none;
}

.Loading {
	width: 100vw;
	height: 100vh;
	display: flex;
	font-size: 30px;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/FlightOrderConfirm.vue